import React from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';

import Base from './Base';

const ALL_KEY = '$ALL';

const valueExtractor = value => value;

const AntSelect = ({ options, mode, allowClear, showSearch, ...props }) => {
  const renderSelect = cProps => (
    <Select
      {...cProps}
      style={{ width: '100%' }}
      showSearch={showSearch}
      mode={mode}
      allowClear={allowClear}
      onChange={values => {
        if (mode !== 'multiple') {
          return cProps.onChange(values);
        }

        const filtered = values.filter(value => value !== ALL_KEY);

        if (values.includes(ALL_KEY) && filtered.length === options.length) {
          return cProps.onChange([]);
        }

        const data =
          filtered.length !== values.length
            ? options.map(({ value }) => value)
            : filtered;
        return cProps.onChange(data);
      }}
    >
      {mode === 'multiple' && (
        <Select.Option key={ALL_KEY} value={ALL_KEY}>
          <b>Select All</b>
        </Select.Option>
      )}
      {options.map(option => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
  return (
    <Base {...props} component={renderSelect} valueExtractor={valueExtractor} />
  );
};

AntSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.any.isRequired,
    }),
  ).isRequired,
  showSearch: PropTypes.bool,
  mode: PropTypes.string,
  allowClear: PropTypes.bool,
};

AntSelect.defaultProps = {
  showSearch: false,
  allowClear: false,
  mode: 'default',
};

export default AntSelect;
